import { Component } from '@angular/core';

/**
 * Component to render a "cl-userinfo" -- with a help icon and help text --
 * this is here to reduce code duplication and make it easier to change the look & feel of the entire app if desired
 */

@Component({
    selector: 'cl-user-info',
    templateUrl: './user-info.component.html',
    styleUrls: ['./user-info.component.scss'],
})
export class ClUserInfoComponent {
    static $name: string = 'clUserInfo';
}
